// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message":"invalid-code__message--1LuCr","note":"invalid-code__note--2ldRO"};